import axios from 'axios'
import {Message} from 'element-ui'
import { UserInfo } from '../lib/AppConstant'
import Cookies from 'js-cookie'

export class ResponseError extends Error {
  constructor (message, code) {
    super(message)
    this.name = 'ResponseError'
    this.code = code
    // 这一步可不写，默认会保存堆栈追踪信息到自定义错误构造函数之前，
    // 而如果写成 `Error.captureStackTrace(this)` 则自定义错误的构造函数也会被保存到堆栈追踪信息
    Error.captureStackTrace(this, this.constructor)
  }
}

const ajax = axios.create({
  baseURL: '/',
  timeout: 10000
})

// 请求拦截（配置发送请求的信息）
ajax.interceptors.request.use((config) => {
  // 处理请求之前的配置
  const userInfoStr = Cookies.get(UserInfo)
  if (userInfoStr != null && userInfoStr.length > 0) {
    const userInfo = JSON.parse(userInfoStr)
    if (userInfo != null && userInfo.token != null && userInfo.token.length > 2) {
      config.headers = {
        'accessToken': userInfo.token + ''
      }
    }
  }
  return config
}, function (error) {
  // 请求失败的处理
  return Promise.reject(error)
})

// 响应拦截（配置请求回来的信息）
ajax.interceptors.response.use((response) => {
  // 处理响应数据
  if (response.status !== 200) {
    return Promise.reject(new ResponseError('操作失败(' + response.status + ')', response.status))
  }
  if (response.data.status === null || response.data.status === undefined) {
    return Promise.reject(new ResponseError('解析status失败', 1000))
  }

  if (response.data.status !== 200) {
    if (response.data.status === 701) {
      const timerId = setTimeout(() => {
        window.location = '/'
        clearTimeout(timerId)
      }, 1000)
      Cookies.remove(UserInfo)
      return Promise.reject(new ResponseError('登录过期', response.data.code))
    }

    if (response.data.message != null && (response.data.message + '').trim().length > 0) {
      Message.error((response.data.message + '').trim())
      return Promise.reject(new ResponseError(response.data.message + '', response.data.code))
    } else {
      return Promise.reject(new ResponseError('操作失败(' + response.data.code + ')', response.data.code))
    }
  }
  // 直接返回数据
  return response.data
}, function (error) {
  // 处理响应失败
  Message.error('操作失败(' + error.message + ')')
  return Promise.reject(error)
})

// export default ajax
export function get (url, param = {}) {
  let urlStr = ''
  for (let i in param) {
    if (param[i] !== '') {
      urlStr += `/${param[i]}`
    }
  }
  return new Promise((resolve, reject) => {
    ajax({ method: 'get', url: url + urlStr }).then(res => {
      resolve(res.result)
    }).catch(err => {
      reject(err)
    })
  })
}

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    ajax({ method: 'post', url, data: data }).then(res => {
      resolve(res.result)
    }).catch(err => {
      reject(err)
    })
  })
}

// export function upLoadImg (url, data = {}, headImg) {
//   return new Promise((resolve, reject) => {
//     ajax({ method: 'post', url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
//       resolve(response)
//     }).catch(err => {
//       Message({ showClose: true, message: '上传失败', type: 'error', duration: 1000 })
//       reject(err)
//     })
//   })
// }



// WEBPACK FOOTER //
// ./src/lib/ajax.js